export const getCookie = (name) => {
  var index  = 0,
      c      = null,
      ca     = decodeURIComponent(document.cookie).split(";"),
      caSize = ca.length;
  name      += "=";

  for( ; index < caSize; index++) {
    c = ca[index];

    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return null;
}

export const setCookie = (name, value, days) => {
  let date, expires

  if (days) {
    date = new Date()
    date.setTime( date.getTime()+(days*24*60*60*1000) )
    expires = "; expires="+date.toGMTString()
  } else {
    expires = ""
  }
  document.cookie = `${name}=${value + expires}; path=/`;
}

export const deleteCookie = (name) => {
  document.cookie = name+'=; Max-Age=-99999999;';
}
